import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withStyles, Typography, Divider, Button } from '@material-ui/core';
import { GetData, PostData } from '../../../api/service';
import ReactToPrint from 'react-to-print';
import Loading from '../Forms/Loading';

const styles = theme => ({

})

class PaymentResponse extends Component {

    state = {
        data: [],
        isLoaded: false
    }

    componentDidMount() {
                
        // PostData(`/getpaymentreceiptnew`, {
        //     email: this.props.user.email
        // })
        //     .then((resp) => {

        //         if (Array.isArray(resp) && resp.length > 0) {
        //             this.setState({
        //                 data: resp[0],
        //                 isLoaded: true
        //             })
        //         } else {
        //             this.props.history.replace('/home')
        //         }
        //     })

        this.props.history.replace('/refinal')
    }


    render() {
        let { classes } = this.props;
        return (
            <div>
                <h1>Payment Response</h1>





                {this.state.isLoaded && this.state.data.transaction != null ? (
                    <Receipt
                        {...this.state.data}
                        ref={el => (this.componentRef = el)}
                    />
                ) : <Loading />}


                <br />
                <br />

                {this.state.isLoaded ? (

                    <div>
                        <ReactToPrint
                            trigger={() =>
                                <Button
                                    variant="outlined"
                                    color="primary"

                                >
                                    Print Receipt
                        </Button>
                            }
                            ref={el => this.buttonRef = el}
                            content={() => this.componentRef}
                            pageStyle={{ margin: '10px' }}
                            copyStyles={true}
                        />

                        <Link to="/refinal">
                            <Button
                                variant="outlined"
                                color="primary"
                            >
                                Print Application Form
                            </Button>
                        </Link>
                    </div>
                ) : null}
            </div>
        )
    }
}

export default withStyles(styles)(PaymentResponse);

class Receipt extends Component {

    render() {
        return (
            <div>
                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="20%">
                                <img
                                    alt="logo"
                                    src={'/images/logo.jpg'}
                                    style={{ width: '50%' }}
                                />
                            </td>

                            <td width="60%" align="center">
                                <Typography
                                    variant="h5"
                                >
                                    BH COLLEGE
                                </Typography>
                                <Typography
                                    variant="body2"
                                >
                                    Howly , Barpeta - 781316
                                </Typography>
                                <Typography
                                    variant="body2"
                                >
                                    Assam
                                </Typography>
                                <Typography
                                    variant="body1"
                                >
                                    Payment Receipt
                                </Typography>
                            </td>

                            <td width="20%" align="center">
                                <Typography
                                    variant="subtitle2"
                                >
                                    Form No. : <b>{this.props.form_id}</b> <br />


                                </Typography>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <br />
                <br />

                <table className="table">

                    <tbody>
                        <tr>
                            <td width="30%">
                                <Typography
                                    variant="body2"
                                >
                                    Name
                                </Typography>
                            </td>

                            <td>
                                <Typography
                                    variant="body2"
                                >
                                    {this.props.name}
                                </Typography>
                            </td>
                        </tr>

                        <tr>
                            <td width="30%">
                                <Typography
                                    variant="body2"
                                >
                                    Form No
                                </Typography>
                            </td>

                            <td>
                                <Typography
                                    variant="body2"
                                >
                                    {this.props.form_id}
                                </Typography>
                            </td>
                        </tr>

                        <tr>
                            <td width="30%">
                                <Typography
                                    variant="body2"
                                >
                                    Transaction Status
                                </Typography>
                            </td>

                            <td>
                                <Typography
                                    variant="body2"
                                >
                                    Success
                                </Typography>
                            </td>
                        </tr>

                        {this.props.receipt_no && <tr>
                            <td width="30%">
                                <Typography
                                    variant="body2"
                                >
                                    Receipt No
                                </Typography>
                            </td>

                            <td>
                                <Typography
                                    variant="body2"
                                >
                                    {this.props.receipt_no}
                                </Typography>
                            </td>
                        </tr>}

                        

                        {this.props.transaction && this.props.transaction.date && <tr>
                            <td width="30%">
                                <Typography
                                    variant="body2"
                                >
                                    Date of Payment
                                </Typography>
                            </td>

                            <td>
                                <Typography
                                    variant="body2"
                                >
                                    {this.props.transaction.date}
                                </Typography>
                            </td>
                        </tr>}

                        {this.props.transaction && this.props.transaction.amount && <tr>
                            <td width="30%">
                                <Typography
                                    variant="body2"
                                >
                                    Amount
                                </Typography>
                            </td>

                            <td>
                                <Typography
                                    variant="body2"
                                >
                                    {this.props.transaction.amount}
                                </Typography>
                            </td>
                        </tr>}


                        {this.props.transaction && this.props.transaction.BANK_Ref_no && <tr>
                            <td width="30%">
                                <Typography
                                    variant="body2"
                                >
                                    Bank Ref No
                                </Typography>
                            </td>

                            <td>
                                <Typography
                                    variant="body2"
                                >
                                    {this.props.transaction.BANK_Ref_no}
                                </Typography>
                            </td>
                        </tr>}

                        {this.props.transaction && this.props.transaction.Ref_no && <tr>
                            <td width="30%">
                                <Typography
                                    variant="body2"
                                >
                                    Txn Ref No
                                </Typography>
                            </td>

                            <td>
                                <Typography
                                    variant="body2"
                                >
                                    {this.props.transaction.Ref_no}
                                </Typography>
                            </td>
                        </tr>}

                        {this.props.mop && <tr>
                            <td width="30%">
                                <Typography
                                    variant="body2"
                                >
                                    Mode of Payment
                                </Typography>
                            </td>

                            <td>
                                <Typography
                                    variant="body2"
                                >
                                    {this.props.mop}
                                </Typography>
                            </td>
                        </tr>}
                    </tbody>

                </table>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/Components/ReRegistration/View/PaymentResponse.js